var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 47,
    viewBox: "0 0 40 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_663_5287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4143 21.5757L29.8486 28.1471H23.2829L17.5378 33.8971V28.1471H10.1514V3.50424H36.4143V21.5757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50991 0.218536L0.302734 8.43282V38.0042H10.1514V46.2185L18.3585 38.0042H24.9243L39.6972 23.2185V0.218536H8.50991ZM36.4143 21.5757L29.8486 28.1471H23.2828L17.5378 33.8971V28.1471H10.1514V3.50425H36.4143V21.5757Z",
    fill: "#9146FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.49 9.25424H28.2072V19.1114H31.49V9.25424Z",
    fill: "#9146FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4621 9.25424H19.1792V19.1114H22.4621V9.25424Z",
    fill: "#9146FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_663_5287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.3945,
    height: 46,
    fill: "white",
    transform: "translate(0.302734 0.218536)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.67f9053d1844934d82e4ec7177b57114.svg";
export { ForwardRef as ReactComponent };